var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HelpList',{on:{"openLogoutModal":function($event){return _vm.$emit('openLogoutModal')},"pushPath":function($event){return _vm.$emit('pushPath', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }